import React, { Fragment, ReactNode } from 'react'
import Link from 'next/link'

interface LinkWrapperProps {
  target?: string;
  href?: string;
  children: ReactNode;
  download?: boolean | undefined;
}

const LinkWrapper = ({ target = '_self', href, children, download }: LinkWrapperProps) => {
  return href ? (
    <Link href={href} passHref legacyBehavior target={target} download={download}>
      {children}
    </Link>
  ) : (
    <Fragment>{children}</Fragment>
  )
}

export default LinkWrapper
